import { useQuery } from "@tanstack/react-query";
import { ApiConfig } from "@/config/api.config";
import { ApiHookProps } from '@/@types/api.types';
import { UrlHelper } from '@/utils/UrlHelper';
import { GetOrderItemsList } from '@/features/orders/types/orders-dto';
import { useAxiosAuth } from '@/hooks/useAxiosAuth';

type Props = {
    serviceId?: string; 
} & ApiHookProps;

export const useOrderItemsListApi = ({ serviceId }: Props = {}) => {
    const axiosInstance = useAxiosAuth();

    const {
        data: orderItemsListData, 
        isLoading: isLoadingOrderItemsListData, 
        isError: isErrorOrderItemsListData,       
    } = useQuery({
        queryKey: [
            ApiConfig.queries.features.hotels.queryKeys.apiRefresh, 
            ApiConfig.queries.features.orders.queryKeys.orderItems, 
            serviceId
        ],
        queryFn: async (): Promise<GetOrderItemsList> => {
            const url = UrlHelper.buildUrlWithQueryParams(ApiConfig.queries.features.orders.endpoints.orderItems, {    
                serviceId
            });
            const response = await axiosInstance.get<GetOrderItemsList>(url);
            return response.data;
        },
        
        enabled: !!serviceId,
    });

    return {
        orderItemsListData,
        isLoadingOrderItemsListData,
        isErrorOrderItemsListData,  
    }
};
